module.exports = __webpack_public_path__ + "static/img/footerImg04.57ad159.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footerImg04.png
// module id = Y50C
// module chunks = 22